import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './content-display-cards-icons-with-image.component.scss';
var ContentDisplayCardsIconsWithImage = /** @class */ (function (_super) {
    tslib_1.__extends(ContentDisplayCardsIconsWithImage, _super);
    function ContentDisplayCardsIconsWithImage(element) {
        return _super.call(this, element) || this;
    }
    ContentDisplayCardsIconsWithImage.prototype.init = function () {
    };
    ContentDisplayCardsIconsWithImage.prototype.bindEvents = function () {
    };
    return ContentDisplayCardsIconsWithImage;
}(Base));
export { ContentDisplayCardsIconsWithImage };



//////////////////
// WEBPACK FOOTER
// ./components/content-display-cards-icons-with-image/content-display-cards-icons-with-image.component.ts
// module id = 226
// module chunks = 0